import { listReducer, cssSelectors } from '@monobits/core';
import { merge } from 'lodash';
var reset_style = {
  '&': {
    margin: '0'
  },
  body: {
    margin: '0'
  },
  textSizeAdjust: '100%',
  WebkitTapHighlightColor: 'transparent',
  main: {
    display: 'block'
  },
  '*:focus': {
    outline: 'none',
    boxShadow: 'none'
  },
  '*::-moz-focus-inner': {
    border: 0
  },
  'a,area,button,input,label,select,textarea,[tabindex]': {
    touchAction: 'manipulation'
  },
  'p,table,blockquote,address,pre,iframe,form,figure,dl': {
    margin: '0'
  },
  'h1,h2,h3,h4,h5,h6': {
    fontSize: 'inherit',
    lineHeight: 'inherit',
    fontWeight: 'inherit',
    margin: '0'
  },
  'ul,ol': {
    margin: '0',
    padding: '0',
    listStyle: 'none'
  },
  dt: {
    fontWeight: 'bold'
  },
  dd: {
    marginLeft: '0'
  },
  hr: {
    boxSizing: 'content-box',
    height: '0',
    overflow: 'visible',
    border: '0',
    borderTop: '1px solid',
    margin: '0',
    clear: 'both',
    color: 'inherit'
  },
  pre: {
    fontFamily: 'monospace, monospace',
    fontSize: 'inherit'
  },
  address: {
    fontStyle: 'inherit'
  },
  a: {
    backgroundColor: 'transparent',
    textDecoration: 'none',
    color: 'inherit'
  },
  'abbr[title]': {
    borderBottom: 'none',
    textDecoration: ['underline', 'underline dotted']
  },
  'b,strong': {
    fontWeight: 'bolder'
  },
  'code,kbd,samp': {
    fontFamily: 'monospace, monospace',
    fontSize: 'inherit'
  },
  small: {
    fontSize: '80%'
  },
  'sub,sup': {
    fontSize: '75%',
    lineHeight: 0,
    position: 'relative',
    verticalAlign: 'baseline'
  },
  sub: {
    bottom: '-0.25em'
  },
  sup: {
    top: '-0.5em'
  },
  img: {
    borderStyle: 'none',
    verticalAlign: 'bottom'
  },
  'embed,object,iframe': {
    border: '0',
    verticalAlign: 'bottom'
  },
  'button,input,optgroup,select,textarea': {
    WebkitAppearance: 'none',
    appearance: 'none',
    verticalAlign: 'middle',
    color: 'inherit',
    font: 'inherit',
    border: '0',
    background: 'transparent',
    padding: '0',
    margin: '0',
    outline: '0',
    borderRadius: '0',
    textAlign: 'inherit'
  },
  '[type="checkbox"]': {
    WebkitAppearance: 'checkbox',
    appearance: 'checkbox'
  },
  '[type="radio"]': {
    WebkitAppearance: 'radio',
    appearance: 'radio'
  },
  'button,input': {
    overflow: 'visible'
  },
  'button,select': {
    textTransform: 'none'
  },
  'button,[type="button"],[type="reset"],[type="submit"]': {
    cursor: 'pointer',
    WebkitAppearance: 'none',
    appearance: 'none'
  },
  'button[disabled],[type="button"][disabled],[type="reset"][disabled],[type="submit"][disabled]': {
    cursor: 'default'
  },
  'button::-moz-focus-inner,[type="button"]::-moz-focus-inner,[type="reset"]::-moz-focus-inner,[type="submit"]::-moz-focus-inner': {
    borderStyle: 'none',
    padding: '0'
  },
  'button:-moz-focusring,[type="button"]:-moz-focusring,[type="reset"]:-moz-focusring,[type="submit"]:-moz-focusring': {
    outline: '1px dotted ButtonText'
  },
  'select::-ms-expand': {
    display: 'none'
  },
  option: {
    padding: '0'
  },
  fieldset: {
    margin: '0',
    padding: '0',
    border: '0',
    minWidth: '0'
  },
  legend: {
    color: 'inherit',
    display: 'table',
    maxWidth: '100%',
    padding: '0',
    whiteSpace: 'normal'
  },
  progress: {
    verticalAlign: 'baseline'
  },
  textarea: {
    overflow: 'auto'
  },
  '[type="number"]::-webkit-inner-spin-button,[type="number"]::-webkit-outer-spin-button': {
    height: 'auto'
  },
  '[type="search"]': {
    outlineOffset: '-2px'
  },
  '[type="search"]::-webkit-search-decoration': {
    WebkitAppearance: 'none'
  },
  '::-webkit-file-upload-button': {
    WebkitAppearance: 'button',
    font: 'inherit'
  },
  'label[for]': {
    cursor: 'pointer'
  },
  details: {
    display: 'block'
  },
  summary: {
    display: 'list-item'
  },
  '[contenteditable]': {
    outline: 'none'
  },
  table: {
    borderCollapse: 'collapse',
    borderSpacing: '0'
  },
  caption: {
    textAlign: 'left'
  },
  'td,th': {
    verticalAlign: 'top',
    padding: '0'
  },
  th: {
    textAlign: 'left',
    fontWeight: 'bold'
  },
  template: {
    display: 'none'
  },
  '[hidden]': {
    display: 'none'
  }
};
/**
 * List of hack styles
 * @type {object}
 */

var hacks = {
  killFontFout: {
    // Prevent fout and rendering jumps
    '&:not([class*=--loaded])': {
      visibility: 'hidden'
    }
  },
  killThemeTransitions: {
    // Prevent transition funk from theme switch
    '&.-in-transition': {
      '*:not(.-with-transition), *:not(.-with-transition)::before, *:not(.-with-transition)::after': {
        transition: 'none!important'
      }
    }
  },
  aspectRatio: {
    // Usefull way to handle aspect ratio
    '.-aspect-ratio, [data-aspect-ratio]': {
      '@supports (aspect-ratio: 1 / 1)': {
        aspectRatio: 'var(--aspect-ratio)'
      },
      '@supports not (aspect-ratio: 1 / 1)': {
        '::after': {
          content: '""',
          pb: 'calc(100% / (var(--aspect-ratio)))',
          display: 'flex'
        }
      }
    }
  },
  userSelect: {
    // Usefull way to change user-select behavior
    '&, & *, & *::before, & *::after': {
      userSelect: 'var(--user-select, unset)'
    }
  }
};
/**
 * Reduces a list of style objects
 *
 * @param  {array} [selected=[]] Array of keys to reduce
 * @returns {array} Reduced array
 */

var hacks_styles = function hacks_styles(selected) {
  if (selected === void 0) {
    selected = [];
  }

  return listReducer(hacks, selected);
};

var base_styles = {
  '*::selection': {
    bg: 'highlight'
  },
  img: {
    width: '100%',
    height: 'auto',
    pointerEvents: 'none',
    '&:not([src])': {
      visibility: 'hidden'
    }
  },
  svg: {
    display: 'flex',
    flexGrow: '1',
    pointerEvents: 'none',
    '&:not(:root)': {
      overflow: 'hidden'
    }
  },
  '._noselect': {
    pointerEvents: 'none',
    userSelect: 'none'
  },
  '._scroller': {
    overflow: 'scroll',
    MsOverflowStyle: 'none',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none'
    }
  },
  WebkitFontSmoothing: 'antialiased',
  MozOsxFontSmoothing: 'grayscale',
  textRendering: 'optimizeLegibility',
  fontFeatureSettings: "'kern', 'liga', 'clig', 'calt'"
};

var _base;

var hidden = ['[data-scroll-locked="true"]'];
var theming = {
  '.c-scrollbar': {
    '--width': '6px',
    '--spacing': '0px',
    '--bar-opacity': 0.1,
    '--thumb-opacity': 0.4,
    color: 'text',
    // :hover
    '--transition': '0.4s ease',
    '--scale': 1.25,
    // bool : 0 / 1
    '--rounded': 0,
    '--visible': 1
  } // '.c-scrollbar_thumb': { color: 'text' },

}; // Base Styles

var base = (_base = {
  '.c-scrollbar': {
    height: '100vh',
    transformOrigin: 'center right',
    '--sum': 'calc((var(--width) + var(--spacing)) * 2)',
    '--hitbox': 'clamp(12px, var(--sum), 30px)',
    opacity: 0,
    transition: 'transform var(--transition), opacity var(--transition)',
    '&:hover': {
      transform: 'scaleX(var(--scale))'
    },
    '::after': {
      width: 'calc(var(--width) + (var(--spacing) * 2.15))',
      opacity: 'calc(var(--bar-opacity, 0.1))'
    }
  },
  '.c-scrollbar_thumb': {
    cursor: 'grab',
    '::after': {
      m: 'var(--spacing)',
      width: 'var(--width, 6px)',
      opacity: 'var(--thumb-opacity, 0.4)',
      borderRadius: 'calc(var(--width) * var(--rounded))'
    }
  },
  '.c-scrollbar,.c-scrollbar_thumb': {
    position: 'absolute',
    right: 0,
    top: 0,
    display: 'flex',
    justifyContent: 'flex-end',
    width: 'var(--hitbox, 16px)',
    '::after': {
      content: '""',
      display: 'flex',
      pointerEvents: 'none',
      bg: 'currentColor'
    }
  }
}, _base[cssSelectors(hidden, {
  prev: '&',
  next: ' .c-scrollbar'
})] = {
  opacity: '0!important'
}, _base['.c-scrollbar:hover,&.has-scroll-dragging .c-scrollbar,&.has-scroll-scrolling .c-scrollbar'] = {
  opacity: 1
}, _base['.has-scroll-dragging .c-scrollbar_thumb'] = {
  cursor: 'grabbing'
}, _base['&.has-scroll-dragging'] = {
  userSelect: 'none'
}, _base['&.has-scroll-smooth,&.has-scroll-smooth body'] = {
  overflow: 'hidden'
}, _base['&.has-scroll-smooth'] = {
  '[data-scroll-container]': {
    minHeight: '100vh'
  }
}, _base);
var locomotive_styles = merge(base, theming);
export { base_styles as base, hacks_styles as hacks, locomotive_styles as locomotive, reset_style as reset };